import { render, staticRenderFns } from "./admincoin.vue?vue&type=template&id=061265f6&scoped=true"
import script from "./admincoin.vue?vue&type=script&lang=js"
export * from "./admincoin.vue?vue&type=script&lang=js"
import style0 from "./admincoin.vue?vue&type=style&index=0&id=061265f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061265f6",
  null
  
)

export default component.exports